export const getSidebarSections = (permissions, portal) => {
    const hasPermission = (name) =>
        permissions?.some((permission) => permission?.name === name);

    // Define all permission checks
    const canView = {
        customer: hasPermission("customer.view"),
        product: hasPermission("product.view"),
        store: hasPermission("vendor.store"),
        property: hasPermission("property.view"),
        vendors: hasPermission("vendor.view"),
        orders: hasPermission("order.view"),
        admins: hasPermission("admin.view"),
        roles: hasPermission("role.view"),
        permissions: hasPermission("permission.view"),
        activityLogs: hasPermission("admin.activities"),
        bills: hasPermission("bill.view"),
        physicalProduct: hasPermission("physical.product.view"),
        switchers: hasPermission("switcher.view"),
        category: hasPermission("category.view"),
        tickets: hasPermission("ticket.view"),
        appSettings: hasPermission("settings.view"),
        slider: hasPermission("settings.view"),
        riders: hasPermission("rider.view") || hasPermission("rider.edit"),
        cluster: hasPermission("settings.view"),
        operations: hasPermission("admin.view"),
        withdrawalRequest: hasPermission("withdrawal.view"),
        walletsHistory: hasPermission("wallet.view"),
        remittance: hasPermission("branch.remittance.view"),
        purchase: hasPermission("branch.purchase.view"),
        stock: hasPermission("stock.view")
    };

    // Admin sidebar sections
    const adminSections = [
        {
            key: "customer",
            title: "Customer",
            show: canView.customer,
            links: [{ to: "/admin/customer", label: "Customers" }],
        },
        {
            key: "product",
            title: "Product",
            show: canView.vendors || canView.product || canView.store || canView.property || canView.category,
            links: [
                canView.vendors && { to: "/admin/products", label: "Product Brands" },
                canView.product && { to: "/admin/products/stock/list", label: "Stock Product" },
                canView.product && { to: "/admin/products/stock/pending", label: "Pending Stock Product" },
                canView.category && { to: "/admin/category/list", label: "Categories" },
                canView.store && { to: "/admin/store/list", label: "Vendor Store" },
                canView.property && { to: "/admin/product/property/list", label: "Property" },
            ].filter(Boolean),
        },
        // {
        //     key: "physicalProduct",
        //     title: "Bills Product Discount",
        //     show: canView.physicalProduct,
        //     links: [{ to: "/admin/physical/product/list", label: "Bills Product discount" }].filter(Boolean)
        // },
        {
            key: "orders",
            title: "Orders",
            show: canView.orders,
            links: [
                canView.orders && { to: "/admin/order/list", label: "Orders" },
                canView.orders && { to: "/admin/customer/order/return", label: "Rejected Items" },
            ].filter(Boolean),
        },
        {
            key: "admin",
            title: "Admin",
            show: canView.admins || canView.permissions || canView.roles || canView.vendors || canView.activityLogs || canView.cluster,
            links: [
                canView.admins && { to: "/admin/view/list", label: "Admins" },
                canView.permissions && { to: "/admin/permission/list", label: "Permissions" },
                canView.roles && { to: "/admin/roles/list", label: "Roles" },
                canView.vendors && { to: "/admin/vendor/list", label: "Vendor" },
                canView.withdrawalRequest && { to: "/admin/vendor/withdrawal/request", label: "Withdrawal Request" },
                canView.activityLogs && { to: "/admin/activity/log", label: "Activity" },
                canView.cluster && { to: "/admin/cluster/location", label: "Cluster Point" },
                canView.admins && { to: "/admin/commission/list", label: "Commission" },
                canView.admins && { to: "/admin/security/question/list", label: "Security Questions" },
            ].filter(Boolean),
        },
        {
            key: "delivey",
            title: "Delivery Management ",
            show: canView.admins,
            links: [{ to: "/admin/delivery/location", label: "Price Management " }],
        },
        {
            key: "bills",
            title: "Bills",
            show: canView.bills || canView.switchers,
            links: [
                canView.bills && { to: "/admin/product/list", label: "Bills Product" },
                canView.bills && { to: "/admin/billers/list", label: "Billers" },
                canView.switchers && { to: "/admin/switchers/list", label: "Switchers" },
                canView.bills && { to: "/admin/product/all/list", label: "Products" },
                canView.bills && { to: "/admin/bills/search", label: "Search Bills" },
                canView.bills && { to: "/admin/physical/product/list", label: "Bills Product discount" },
            ].filter(Boolean),
        },
        {
            key: "riders",
            title: "Riders",
            show: canView.riders,
            links: [{ to: "/admin/riders/list", label: "Riders" }],
        },
        {
            key: "tickets",
            title: "Tickets",
            show: canView.tickets,
            links: [{ to: "/admin/help/list", label: "Help Center" }],
        },
        {
            key: "Settings",
            title: "Settings",
            show: canView.cluster || canView.appSettings || canView.slider,
            links: [
                // canView.cluster && { to: "/admin/cluster/location", label: "Cluster Point" },
                canView.appSettings && { to: "/admin/appsettings/list", label: "App Settings" },
                canView.slider && { to: "/admin/slider/list", label: "Slider" },
            ].filter(Boolean),
        },


    ];

    // Operations sidebar sections
    const operationsSections = [
        {
            key: "Branch",
            title: "Branch",
            show: canView.admins,
            links: [
                canView.admins && { to: "/operations/branch/list", label: "Branch" },
            ].filter(Boolean)
        },
        {
            key: "Report",
            title: "Report",
            show: canView.admins,
            links: [
                canView.admins && { to: "/operations/branch/dashboard", label: "Branch Dashboard" },
                canView.admins && { to: "/operations/branch/reports", label: "Top Branch" },
            ].filter(Boolean)
        },
        {
            key: "Product",
            title: "Product",
            show: canView.admins,
            links: [
                // canView.admins && { to: "/operations/branch/products", label: "Stocks" },
                canView.admins && { to: "/operations/branch/products/category", label: "Products category" },
                canView.admins && { to: "/operations/branch/product/unit", label: "Manage Product" },
            ].filter(Boolean)
        },
        {
            key: "Purchase",
            title: "Product Purchase",
            show: canView.purchase,
            links: [

                canView.purchase && { to: "/operations/branch/purchase/item", label: "Stock" },
                canView.purchase && { to: "/operations/branch/purchase/pending", label: "Pending Stock" },
                // canView.admins && { to: "/operations/branch/purchase/bulk", label: "Bulk Stock" },
            ].filter(Boolean)
        },
        {
            key: "Stock Monitoring",
            title: "Stock Monitoring",
            show: canView.stock,
            links: [
                canView.stock && { to: "/operations/branch/stock/monitoring", label: "All " },
            ].filter(Boolean),
        },

        // {
        //     key: "Remittance",
        //     title: "Remittance",
        //     show: canView.remittance,
        //     links: [
        //         canView.remittance && { to: "/operations/branch/remittance", label: "All " },
        //         // canView.remittance && { to: "/operations/branch/remittance/pending", label: "Pending" },
        //         // canView.remittance && { to: "/operations/branch/remittance/process", label: "Process" },
        //         // canView.remittance && { to: "/operations/branch/remittance/deducted", label: "Deducted" },
        //         // canView.remittance && { to: "/operations/branch/remittance/bulk", label: "Bulk" },
        //     ].filter(Boolean),
        // },
        {
            key: "Expenses",
            title: "Expenses",
            show: canView.admins,
            links: [
                canView.admins && { to: "/operations/branch/expenses", label: "Expenses" },
            ].filter(Boolean),
        },
        {
            key: "Transaction",
            title: "Transaction",
            show: canView.admins,
            links: [
                canView.admins && { to: "/operations/branch/transaction/history", label: "Transaction History" },
            ].filter(Boolean),
        },

    ];

    // Head Office sidebar sections
    const headOfficeSections = [
        // {
        //     key: "dashboard",
        //     title: "Dashboard",
        //     show: true,
        //     links: [
        //         { to: "/head-office/dashboard", label: "Overview" },
        //     ].filter(Boolean),
        // },
        {
            key: "headOfficeManagement",
            title: "Head Office",
            show: canView.admins,
            links: [
                canView.admins && { to: "/head-office/list", label: "All Head Offices" },
                canView.admins && { to: "/head-office/create", label: "Create New" },
            ].filter(Boolean),
        },
    ];

    // Common sections (appear in both portals)
    // const commonSections = [
    //     {
    //         key: "Profile",
    //         title: "Profile",
    //         show: true,
    //         links: [
    //             { to: "/admin/account/2fa/update/status", label: "2FA Status" },
    //             { to: "/admin/password/change", label: "Change Password" },
    //         ].filter(Boolean),
    //     }
    // ];

    // Return different sections based on portal
    if (portal === "admin") {
        return [...adminSections];
    } else if (portal === "operations") {
        return [...operationsSections];
    } else if (portal === "head-office") {
        return [...headOfficeSections];
    } else {
        return [...adminSections];
    }
};